export default {
  EXAM_WITHDRAWALS: "exams/withdrawals",
  EXAM_WITHDRAWAL: (no) => `exams/withdrawals/show?no=${no}`,
  UPDATE_WITHDRAWAL: "exams/withdrawals/update",
  DELETE_EXAM_WITHDRAWAL: "exams/withdrawals/delete",
};
